import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		// MUI v5 Button defaults to color="primary" (v4 defaulted to the neutral
		// "default" color), and for variant="text" it emits `color: palette.primary.main`
		// on its own styled root class. That rule and the class below are both a single
		// class of specificity, so the winner is decided by emotion's insertion order —
		// and MUI's is inserted last, which is why pinning the color alone (MAX-4133)
		// left the nav teal. Doubling the selector ("&&") outranks it outright (MAX-4248).
		topMenuItem: {
			"&&": {
				textTransform: "none",
				fontWeight: 300,
				color: theme.palette.custom.textSecondary, // #5F6368
				"&:hover": {
					backgroundColor: "transparent",
					color: theme.palette.custom.textPrimary,
					"& svg": {
						color: theme.palette.secondary.main,
					},
				},
			},
		},
		navItems: {
			display: "flex",
			justifyContent: "center",
			gap: 24,
		},
		// Outranks both the MUI root rule and the doubled inactive selector above, so the
		// active color does not depend on the order emotion inserts the two tss classes.
		topMenuItemActive: {
			"&&&": {
				color: theme.palette.custom.textPrimary,
				"& svg": {
					color: theme.palette.secondary.main,
				},
			},
		},
		label: {
			marginLeft: theme.spacing(1),
			whiteSpace: "nowrap",
		},
	} satisfies Record<string, CSSObject>);
};
